var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.10596 18.9058L3.05296 23.7178C3.26285 25.4497 4.75503 26.7558 6.53096 26.7622H23.4685C25.2329 26.76 26.7207 25.4703 26.942 23.7512L27.894 18.9058H2.10596Z",
    fill: "#DF0E0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 16.4507C1.33579 16.4507 1 16.7804 1 17.1872C1 17.594 1.33579 17.9238 1.75 17.9238H28.25C28.6642 17.9238 29 17.594 29 17.1872C29 16.7804 28.6642 16.4507 28.25 16.4507H1.75Z",
    fill: "#DF0E0E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 27.7441V28.7262C7.5 28.9974 7.72386 29.2172 8 29.2172H9C9.27614 29.2172 9.5 28.9974 9.5 28.7262V27.7441H7.5Z",
    fill: "#DF0E0E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 27.7441V28.7262C20.5 28.9974 20.7239 29.2172 21 29.2172H22C22.2761 29.2172 22.5 28.9974 22.5 28.7262V27.7441H20.5Z",
    fill: "#DF0E0E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.9596V4.18966C3.00569 3.27364 3.44103 2.41135 4.18 1.85237C5.00822 1.29944 6.02773 1.09602 7.01 1.28769C7.55058 1.36935 8.06907 1.55634 8.535 1.83764C9.01415 2.1969 9.45778 2.59968 9.86 3.04065C9.87372 3.05509 9.88879 3.06824 9.905 3.07994L8.465 4.43517L7.54 3.5906C7.10088 3.18586 6.45865 3.0765 5.90641 3.31243C5.35417 3.54836 4.99783 4.08435 5 4.67577V15.9596H3Z",
    fill: "#DF0E0E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41081 8.19087C9.30791 8.29375 9.16416 8.34701 9.01771 8.33651C8.87126 8.32601 8.73691 8.25283 8.65031 8.13637C7.65351 6.76907 7.81041 4.89427 9.02114 3.70514C10.2319 2.51601 12.1409 2.36174 13.5333 3.34051C13.6519 3.42556 13.7264 3.55749 13.7371 3.70132C13.7478 3.84514 13.6936 3.98631 13.5888 4.08736L9.41081 8.19087Z",
    fill: "#DF0E0E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4395 9.9585L11.1465 10.6528",
    stroke: "#DF0E0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3892 5.09766L16.0962 5.79197",
    stroke: "#DF0E0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9141 7.52783L13.6216 8.22263",
    stroke: "#DF0E0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3892 7.18066L16.0962 7.87547",
    stroke: "#DF0E0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5605 9.9585L13.268 10.6528",
    stroke: "#DF0E0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0356 9.61133L15.7426 10.3056",
    stroke: "#DF0E0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5605 12.0415L13.268 12.7358",
    stroke: "#DF0E0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5107 7.18066L18.2177 7.87547",
    stroke: "#DF0E0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/bath.bc1cece36c095c9f9639e4b0ecdafd7d.svg";
export { ForwardRef as ReactComponent };